import type * as Types from './types';

import {
  useQuery,
  type QueryClient,
  type UseQueryOptions,
  type FetchQueryOptions,
} from '@tanstack/react-query';
import type { DXError } from '@dx-ui/types-graphql';

export const Countries_AddressOptionsDocument = {
  operationName: 'countries_AddressOptions',
  operationString: `query countries_AddressOptions($language: String!, $code: String!, $type: AddressOptionsAddressType) {
  countries(language: $language, filter: {code: $code}) {
    code
    name
    addressOptions(type: $type) {
      name_noTx: name
      label
      maxLength
      required
      regexValidation
      type_noTx: type
      options {
        label
        value
      }
    }
    enrollmentConfig {
      isPostalCodeLookupEnabled
    }
  }
}`,
  originalOpName: 'countries_AddressOptions',
};

export function useCountries_AddressOptionsQuery<
  TData = Types.Countries_AddressOptionsQuery,
  TError = DXError,
>(
  variables: Types.Countries_AddressOptionsQueryVariables,
  options?: Omit<UseQueryOptions<Types.Countries_AddressOptionsQuery, TError, TData>, 'queryKey'>
) {
  return useQuery<Types.Countries_AddressOptionsQuery, TError, TData>({
    queryKey: [Countries_AddressOptionsDocument, variables],
    ...options,
  });
}

export function serverSideCountries_AddressOptionsQuery(
  queryClient: QueryClient,
  variables: Types.Countries_AddressOptionsQueryVariables,
  options?: FetchQueryOptions<Types.Countries_AddressOptionsQuery>
) {
  return queryClient.fetchQuery<Types.Countries_AddressOptionsQuery>({
    queryKey: [Countries_AddressOptionsDocument, variables],
    ...options,
  });
}

export const GeocodeDocument = {
  operationName: 'geocode',
  operationString: `query geocode($postalCode: String!, $language: String!) {
  geocode(language: $language, postalCode: $postalCode) {
    match {
      address {
        city
        state
      }
    }
  }
}`,
  originalOpName: 'geocode',
};

export function useGeocodeQuery<TData = Types.GeocodeQuery, TError = DXError>(
  variables: Types.GeocodeQueryVariables,
  options?: Omit<UseQueryOptions<Types.GeocodeQuery, TError, TData>, 'queryKey'>
) {
  return useQuery<Types.GeocodeQuery, TError, TData>({
    queryKey: [GeocodeDocument, variables],
    ...options,
  });
}

export function serverSideGeocodeQuery(
  queryClient: QueryClient,
  variables: Types.GeocodeQueryVariables,
  options?: FetchQueryOptions<Types.GeocodeQuery>
) {
  return queryClient.fetchQuery<Types.GeocodeQuery>({
    queryKey: [GeocodeDocument, variables],
    ...options,
  });
}
